'use client';
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { track } from "@vercel/analytics/react";
import { pinterest } from '@/lib/pinterest'; // Add this import


// Define props interface with optional CSS class names
interface SearchComponentProps {
  containerClassName?: string;
  formClassName?: string;
  inputWrapperClassName?: string;
  buttonClassName?: string;
  inputClassName?: string;
}

export const SearchComponent = ({
  containerClassName = "search-component",
  formClassName = "relative",
  inputWrapperClassName = "input-wrapper",
  buttonClassName = "search-button absolute left-2 top-0 h-full px-4",
  inputClassName = "w-full py-3 input-text"
}: SearchComponentProps) => {
    const [input, setInput] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);
    const [searchCount, setSearchCount] = useState(0);

    const router = useRouter();
    const suggestions = [
      "Try 'Books to change my perspective on success'...",
      "Try 'Mind-binding reads'...",
      "Try 'Feel good romance with happy ending'...",
      "Try 'Marriage-themed thrillers'...",
      "Try 'Women in war history'...",
      "Try 'Dark, violent epic fantasy'...",
      "Try 'Books like the three-body problem'..."
    ];
    useEffect(() => {
      const savedCount = sessionStorage.getItem('zilu_total_searches');
      if (savedCount) {
        setSearchCount(parseInt(savedCount, 10));
      }
    }, []);
  
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => 
          prevIndex === suggestions.length - 1 ? 0 : prevIndex + 1
        );
      }, 3000);
      return () => clearInterval(interval);
    }, [suggestions.length]);
  
    const handleSearch = async (e: React.FormEvent) => {
      track("search made")
      e.preventDefault();
      pinterest.trackSearch(input.trim());
    
      // Increment search count
    
  
      if (input.trim()) {
        const newCount = searchCount + 1;
        setSearchCount(newCount);
        sessionStorage.setItem('zilu_total_searches', newCount.toString());
        
        // Track quality users
        if (newCount === 3 || newCount === 10) {
          pinterest.trackQualityUser(newCount);
        }
        sessionStorage.setItem('lastExactQuery', input.trim());
        
        const slugifiedQuery = input.trim()
        .toLowerCase()
        .replace(/[\/\?\#\:\*\[\]\@\!\$\&\'\(\)\+\,\;\=]/g, '-')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
          
        router.push(`/discover/${slugifiedQuery}`);
      }
    };
    
    return (
      <div className={containerClassName}>
        <form onSubmit={handleSearch} className={formClassName} noValidate>
          <div className={inputWrapperClassName}>
            <button type="submit" className={buttonClassName} aria-label="Search">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.91429 16H10.0857L12.1429 11.9714L16 10L12.1429 8.02857L10.0857 4H9.91429L7.94286 8.02857L4 10L7.94286 11.9714L9.91429 16Z" fill="#555555"/>
                <path d="M4.85714 15.1429C5.33053 15.1429 5.71429 14.7591 5.71429 14.2857C5.71429 13.8123 5.33053 13.4286 4.85714 13.4286C4.38376 13.4286 4 13.8123 4 14.2857C4 14.7591 4.38376 15.1429 4.85714 15.1429Z" fill="#555555"/>
                <path d="M14.2857 6.57143C14.7591 6.57143 15.1429 6.18767 15.1429 5.71429C15.1429 5.2409 14.7591 4.85714 14.2857 4.85714C13.8123 4.85714 13.4286 5.2409 13.4286 5.71429C13.4286 6.18767 13.8123 6.57143 14.2857 6.57143Z" fill="#555555"/>
              </svg>
            </button>
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder={suggestions[currentIndex]}
              className={inputClassName}
              required
            />
          </div>
        </form>
      </div>
    );
};